var FAQs = React.createClass({
    mixins: [React.addons.PureRenderMixin],

    render: function() {
        return (
            <div>
				<h1>Frequently Asked Questions</h1>
				<hr />
				<ol>
					<li>
						<b>How is this site back?</b>
					</li>
					Through a lot of time and effort, the old site was recovered, rebuilt and although its a
					steep learning curve, the site will get better and better in time.{'\n'}
					<li>
						<b>Why did you even bring this site back?</b>
					</li>
					Honestly, the site was rebuilt to bring friends together, who have minimal demands and
					needs. If you are looking for a place to complain about missing features and broken links,
					this site isnt for you. If you're looking to troll, keep it clean, but if you're going to
					be rude, we will definitely show you the way out.
					<li>
						<b>OMG Can you please add Hover Kart?</b>
					</li>
					We are working on it. If it's meant to be, you will see it in the game list :)
					<li>
						<b>Am I safe here? #PrivacyInvasion?</b>
					</li>
					This site is run by one solo admin who honestly couldnt care less about your data. That
					said, hes a huge believer in privacy and data encryption, so all data stored is either
					hashed or encrypted and cannot be read, whether its in private chats or game rooms or
					whether its your email or password.{' '}
					<p>
						{' '}
						Plus, honestly, no one here has time to read the shit you get up to in your private
						rooms. Just, keep it private and your information will be secure here.
					</p>
					<li>
						<b>Can I help?</b>
					</li>
					Contact the admin and see what you could do to help out!
				</ol>
				<h1>
					MOBC
					<img
						src="https://mobcpop.com/mcoin.png"
						height="22px"
					/>
					IN
				</h1>
				<hr />
				<ol>
					<li>
						<b>What is this coin?</b>
					</li>
					Just to keep the site active and reward people who play, we have introduced a currency
					system. It is still under testing but in the future it will have more use.{'\n'}
					<li>
						<b>How do I get coins?</b>
					</li>
					Win games, win tournaments when we have any, or in the future, trade or gamble them in
					other games. For now, the coins are coming in a few games at a time, to make sure the
					coins work fine.
					<li>
						<b>Where can I spend them?</b>
					</li>
					There will be a 'shop' that allows you to purchase rare items, or trade your coins in for
					other things like a custom badge, user renaming, and even special powers (like not being
					kicked for a certain amount of days, etc.). That is still in the works, so stay tuned.
					<li>
						<b>Can I help?</b>
					</li>
					Contact the admins if things dont seem like they are working they should be.
				</ol>
				<SeeAlso />
			</div>
        )
    },
})